import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { CustomerRatingComponent } from '../../app/content/layout/components/product/customer-rating/customer-ratingcomponent';
import { withCommonDecorators } from '../_utils/story-helpers';
import { createDamilanoBarberaProduct } from '../_mocks';
import { signal } from '@angular/core';
import { CustomerReviewsAndWishlistService } from '../../app/core/services/customer-reviews-and-wishlist.service';

const product = createDamilanoBarberaProduct();

function withReviews(reviews: any[] = []) {
  return {
    provide: CustomerReviewsAndWishlistService,
    useValue: {
      customerReviews: signal(reviews),
      wishlist: signal([]),
      addReviewProduct: () => {},
      adjustWishlist: () => {},
    },
  };
}

const meta: Meta<CustomerRatingComponent> = {
  title: 'Atoms/Customer Rating',
  component: CustomerRatingComponent,
  parameters: {
    layout: 'centered',
    docs: {
      description: {
        component: 'Star-based customer rating component allowing users to rate products.',
      },
    },
  },
};

export default meta;
type Story = StoryObj<CustomerRatingComponent>;

export const Default: Story = {
  decorators: [...withCommonDecorators([withReviews()])],
  args: {
    product: product as any,
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('.customer-rating')).toBeTruthy();
  },
};

export const WithExistingReview: Story = {
  decorators: [...withCommonDecorators([withReviews([
    { product: { id: product.id }, rating: 4 },
  ])])],
  args: {
    product: product as any,
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('.customer-rating')).toBeTruthy();
  },
};

export const CustomStarColor: Story = {
  decorators: [...withCommonDecorators([withReviews()])],
  args: {
    product: product as any,
    starColor: '#e91e63',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('.customer-rating')).toBeTruthy();
  },
};

export const LargeStars: Story = {
  decorators: [...withCommonDecorators([withReviews()])],
  args: {
    product: product as any,
    starHeight: '32px',
    starWidth: '32px',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('.customer-rating')).toBeTruthy();
  },
};

export const SmallStars: Story = {
  decorators: [...withCommonDecorators([withReviews()])],
  args: {
    product: product as any,
    starHeight: '14px',
    starWidth: '14px',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('.customer-rating')).toBeTruthy();
  },
};
